export default function getUrlParameter(name) {
  const key = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${key}=([^&#]*)`);
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export const range = (start, end) => {
  if (typeof start !== 'number' || typeof end !== 'number') return null;

  const size = end - start;
  if (size <= 0) return null;

  return [...Array(size).keys()].map(i => i + start);
};

export const random = (min, max) => {
  const _min = Math.ceil(min);
  const _max = Math.floor(max);
  return Math.floor(Math.random() * (_max - _min + 1)) + _min;
};

export const cacheTableOptions = (key, value) => {
  if (!value) return;

  const previousStore = JSON.parse(sessionStorage.getItem(key));
  const nextStore = { ...previousStore, ...value };

  sessionStorage.setItem(key, JSON.stringify(nextStore));
};

export const removeWhiteSpace = (value) => {
  if (value !== undefined) {
    return value.trim();
  }
  return undefined;
}

export const getTableOptions = (key) => {
  const cachedState = JSON.parse(sessionStorage.getItem(key));
  if (!cachedState) return;

  const state = {
    ...cachedState,
    initialValues: {
      searchBy: cachedState.searchBy,
      searchData: cachedState.searchData,
      filterBy: cachedState.filterBy,
    },
  };

  delete state.searchBy;
  delete state.searchData;
  delete state.filterBy;

  return state;
};

export const filterCustomersByProduct = (product, customers, customerId, isATSysAdmin) => {
  if (product === 'all') {
    return customers;
  }
  let customerList = [];
  if (product === 'aci') {
    customerList = customers.filter(c => !c.product || c.product.includes(product));
  } else {
    customerList = customers.filter(c => c.product && c.product.includes(product));
  }

  if (!isATSysAdmin) return customerList.filter(c => c.customerId === customerId);
  return customerList;

};

export const filterLocationsByProduct = (locations, customers) => {
  return locations.filter(loc => customers.find(({ customerId }) => loc.customerId === customerId));
};

export const decodeJwtToken = token => JSON.parse(atob(token.split('.')[1]));

export const hasJwtTokenExpired = (token) => {
  const decodedToken = decodeJwtToken(token);
  const currentTimeEpoch = Math.round(new Date().getTime() / 1000);

  return decodedToken.exp <= currentTimeEpoch;
};

export const isObjectEmpty = (obj) => {
  if (obj == null) return true;
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;
  if (typeof obj !== 'object') return true;
  for (const key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }
  return true;
};

export const filterPersonLocationsByProduct = (personLocations, locations) => {
  return personLocations.filter(loc => locations.find(({ locationId }) => loc.locationId === locationId));
};

export const filterUsersByProduct = (users, locations, usersFilteredByProduct, isATSysAdmin) => {
  const filteredUserList = users.filter(user => usersFilteredByProduct.find(({ personId }) => user.personId === personId));
  const userList = users.filter(user => !locations.some(({ personId }) => user.personId === personId));
  if (isATSysAdmin) {
    const combinedList = userList.concat(filteredUserList);
    return combinedList.filter((v, i, a) => a.findIndex(t => (t.personId === v.personId)) === i);
  }
  return filteredUserList;
};

export const isUserATSysAdmin = (customerId) => {
  if (['56159d84-123e-4408-9b39-ad64589c3a1b',
   'be801da4-f625-4105-8fdc-ffd2f6ca5107',
   'ad1dd42b-2e1a-492f-bfbd-2d8a35393447',
   'dc3daf67-5f8e-47fa-99b4-748ab2330f15',
   'a8f84a5e-904f-4fbb-82f1-ef0bf3128a27',
   '6d627d77-c63e-4773-970c-f408153fabf9',
   'f87cc5ce-13e8-4894-b6eb-cce038a74436'].includes(customerId)) {
    return true;
  }
  return false;
}


// WEBPACK FOOTER //
// ./src/helpers/Util.js